const indicatorsTemplate = require("templates/photos/shopable-indicators.hbs");
const linksTemplate = require("templates/photos/shopable-links.hbs");

if (typeof L2H === 'undefined' || L2H === null) { window.L2H = {}; }


const SHOPABLE_RADIUS = 10;

L2H.ShopablesView = class ShopablesView {
  constructor(shopables, $container, options) {
    this.shopables = shopables;
    this.$container = $container;
    this.options = options;
    this.linkTarget = this.options.openShopableLinksInNewWindow ? "_blank" : "_self";
    this.bindEvents();
    this.hoverEnabled = $('.l2h-working-hover').length;
  }

  bindEvents() {
    const self = this;
    this.$container
      .on('click', '.l2h-shopables-wrapper', e => self.toggleShopableVisibility())
      .on('mouseenter', '.shopable-link', function(e) {
        if (self.hoverEnabled) { self.handleShopableLinkEvent(this, 'mouseenter'); }
      }).on('mouseleave', '.shopable-link', function(e) {
        if (self.hoverEnabled) { self.handleShopableLinkEvent(this, 'mouseleave'); }
      }).on('mouseenter', '.shopable-indicator', function(e) {
        if (self.hoverEnabled) { self.handleShopableIndicatorEvent(this, 'mouseenter'); }
      }).on('mouseleave', '.shopable-indicator', function(e) {
        if (self.hoverEnabled) { self.handleShopableIndicatorEvent(this, 'mouseleave'); }
      }).on('mouseenter', '.l2h-shopables-wrapper', function(e) {
        if (self.hoverEnabled) { self.showShopables(); }
      }).on('mouseleave', '.l2h-shopables-wrapper', function(e) {
        if (self.hoverEnabled) { self.hideShopables(); }
      });

    return $(window).on("throttledresize", function(e) {
      if (self.shopables.length) { return self.render(); }
    });
  }

  render(shopables) {
    if (shopables != null) { this.shopables = shopables; }

    const $photoContainer = this.$container.find('.l2h-product-photo');

    const photoWidth = $photoContainer.outerWidth();
    const photoHeight = $photoContainer.outerHeight();
    const styledShopables = this.styledShopableIndicators(photoWidth, photoHeight, SHOPABLE_RADIUS);

    const context = {
      shopables: styledShopables,
      single: (this.shopables.length === 1) && L2H.preferences.showShopitButton,
      linkTarget: this.linkTarget,
      preferences: L2H.preferences
    };

    if (L2H.preferences.showProductPhotos) {
      context.shopablesWithPhoto = this.shopablesWithPhoto(styledShopables);
      context.shopablesWithoutPhoto = this.shopablesWithoutPhoto(styledShopables);
    }

    const renderedIndicators = indicatorsTemplate(context);
    this.$container.find('.l2h-shopable-indicators').html(renderedIndicators);

    const renderedLinks = linksTemplate(context);
    this.$container.find('.l2h-shopable-links').html(renderedLinks);

    if (!this.hoverEnabled) { return this.showShopables(); }
  }

  shopablesWithPhoto(shopables) {
    return shopables.filter(shopable => shopable.product && shopable.product.photo_url);
  }

  shopablesWithoutPhoto(shopables) {
    return shopables.filter(shopable => !(shopable.product && shopable.product.photo_url));
  }

  styledShopableIndicators(photoWidth, photoHeight, shopableRadius) {
    return this.shopables.map((shopable, index) => {
      return $.extend({}, shopable, {index: index + 1, style: this.styleForShopable(shopable, photoWidth, photoHeight, shopableRadius)});
    });
  }

  styleForShopable(shopable, photoWidth, photoHeight, radius) {
    const w = radius * 2;
    const h = w;

    const top  = (shopable.y * photoHeight) - radius;
    const left = (shopable.x * photoWidth)  - radius;
    return `width:${w}px; height:${h}px; line-height:${h}px; border-radius:${radius}px; top:${top}px; left:${left}px;`;
  }

  showShopables() {
    return this.$container.find('.shopable-indicator').removeClass('hidden');
  }

  hideShopables() {
    return this.$container.find('.shopable-indicator').addClass('hidden');
  }

  toggleShopableVisibility() {
    return this.$container.find('.shopable-indicator').toggleClass('hidden');
  }

  handleShopableLinkEvent(el, type) {
    const $indicator = $(`#shopable-indicator-${$(el).data('shopable-id')}`);
    switch (type) {
    case "mouseenter":
      $indicator
        .addClass('l2h-highlighted')
        .removeClass('hidden');
      break;
    case "mouseleave":
      $indicator
        .removeClass('l2h-highlighted')
        .addClass('hidden');
      break;
    }
  }

  handleShopableIndicatorEvent(el, type) {
    const $link = $(`#shopable-link-${$(el).data('shopable-id')}`);
    switch (type) {
    case "mouseenter":
      $link.addClass('active');
      break;
    case "mouseleave":
      $link.removeClass('active');
      break;
    }
  }
};
